import _ from 'lodash';
import { Component, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { last, takeUntil } from 'rxjs/operators';
import { selectDialogState } from 'app/dialog/features/dialog.selectors';
import { DialogService } from 'app/dialog/services/dialog.service';
import * as ExcelJS from 'exceljs/dist/exceljs';
import { VolunteersImportService } from 'app/import-volunteers/services/volunteers-import.service';
import { CommonModule } from '@angular/common';
import { VolunteersImportXlsxComponent } from '../volunteers-import-xlsx/volunteers-import-xlsx.component';
import { LoadingService } from 'app/core/services/loading.service';

@Component({
  selector: 'app-volunteers-import',
  standalone: true,
  imports: [CommonModule, VolunteersImportXlsxComponent],
  templateUrl: './volunteers-import.component.html',
  styleUrl: './volunteers-import.component.scss'
})
export class VolunteersImportComponent implements OnDestroy{

  public takeUntilSubject: Subject<any> = new Subject();
  public dialog$: Observable<any> = this.store.pipe(select(selectDialogState));

  public readmore: boolean = false;
  public import: FormControl = new FormControl(null, []);

  public step: string = 'import';
  public disableUpload: boolean = false;
  public finalIcon: string = '<i class="fas fa-check-circle green-text headline-2--weight-900"></i>'

  public validEmails: number = 0;
  public invalidEmails: number = 0;

  constructor(
    private store: Store,
    private dialogService: DialogService,
    public volunteersImportService: VolunteersImportService,
    private loadingService: LoadingService,
    
  ) { }

  ngOnInit(): void {
    this.dialog$.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((dialog) => {
      this.volunteersImportService.existingVolunteerList = dialog.initialState.volunteerList;
    })
  }

  downloadExcelTemplate() {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('Volunteers');

    sheet.columns = [
      { header: 'Email', headerStyle: { bold: true }, width: 20 },
    ];;

    workbook.xlsx.writeBuffer().then((buffer) => {
      return this.saveAsExcelFile(buffer);
    });
  }

  private saveAsExcelFile(buffer){
    const blob: Blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.download = 'sample_volunteers_import';
    downloadLink.click();
  }

  onChangeData(response) {
    this.step = 'review';
    this.volunteersImportService.volunteerList = response.volunteerEmails;
    
    this.validEmails = this.volunteersImportService.volunteerList.filter(item => item.status === 1).length;
    this.invalidEmails = this.volunteersImportService.volunteerList.filter(item => item.status === 0).length;

    if (response.isValid) {
      this.disableUpload = false;
    } else {
      this.disableUpload = true;
    }
  }

  onBackClick() {
    this.step = 'import';
    this.volunteersImportService.volunteerList = [];
    this.import.reset();
  }

  onUpload() {
    this.loadingService.enabled = false;

    this.volunteersImportService.addVolunteerList(this.volunteersImportService.volunteerList).pipe(
      last(),
      takeUntil(this.takeUntilSubject),
    ).subscribe((response) => {
      this.loadingService.enabled = true;
      
      if(this.volunteersImportService.failedCount !== 0){
        this.finalIcon = '<i class="fas fa-check-circle yellow-text headline-2--weight-900"></i>'
      } else if (this.volunteersImportService.successfulCount == 0){
        this.finalIcon = '<i class="fas fa-check-circle red-text headline-2--weight-900"></i>'
      }

      this.step = 'completed';
      this.volunteersImportService.volunteerList = [];
    })
  }

  onClose(dialog) {
    this.close(dialog, true);
  }

  close(dialog, value) {
    this.dialogService.closeDialogSubject.next(value);

    const { initialState: { callback } } = dialog;
    callback(true);
  }

  onToggleReadMore() {
    this.readmore = !this.readmore;
  }

  ngOnDestroy(): void {
    this.dialogService.closeDialogSubject.next(null);

    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }
}
